module.exports = __webpack_public_path__ + "static/media/perfilF.a2ca405b.jpg";